import { c as _c } from "react/compiler-runtime";
import style from './InputPhone.module.scss';
const PATTERN = /\D/g;
const getInputNumbersValue = value => {
  return value.replace(PATTERN, '');
};
const handlePhoneInput = event => {
  const input = event.target;
  let formattedInputValue = '';
  const selectionStart = input.selectionStart;
  let inputNumbersValue = getInputNumbersValue(input.value);
  if (!inputNumbersValue) {
    input.value = '+7';
    return;
  }
  if (input.value.length !== selectionStart) {
    return;
  }
  const firstSymbol = '+7';
  formattedInputValue = `${firstSymbol} `;
  if (inputNumbersValue[0] === '') {
    inputNumbersValue = ' ';
  }
  if (inputNumbersValue[0] === '0') {
    inputNumbersValue = '';
  }
  if (inputNumbersValue[0] !== '8' && inputNumbersValue[0] !== '7') {
    inputNumbersValue = '7' + inputNumbersValue;
  }
  if (inputNumbersValue.length > 1) {
    formattedInputValue += '(' + inputNumbersValue.slice(1, 4);
  }
  if (inputNumbersValue.length >= 5) {
    formattedInputValue += ') ' + inputNumbersValue.slice(4, 7);
  }
  if (inputNumbersValue.length >= 8) {
    formattedInputValue += '-' + inputNumbersValue.slice(7, 9);
  }
  if (inputNumbersValue.length >= 10) {
    formattedInputValue += '-' + inputNumbersValue.slice(9, 11);
  }
  input.value = formattedInputValue;
};
const handleBackspaceAtStart = (input, event) => {
  if (input.selectionStart <= 2) {
    event.preventDefault();
    return true;
  }
  return false;
};
const handleBackspaceInParentheses = (input, event) => {
  if (input.value.split(')')[0].split('(')[1].length < 3 && input.selectionStart === 3) {
    event.preventDefault();
    return true;
  }
  return false;
};
const handleBackspaceAtSpecialPositions = (input, event) => {
  const specialPositions = [3, 4, 9, 8, 13, 16];
  if (specialPositions.includes(input.selectionStart)) {
    const newPosition = input.selectionStart === 4 ? 2 : input.selectionStart - 1;
    input.setSelectionRange(newPosition, newPosition);
    if (input.selectionStart !== 4) {
      event.preventDefault();
    }
    return true;
  }
  return false;
};
const handlePhoneKeyDown = event => {
  const input = event.target;
  if (event.key === 'Backspace') {
    if (getInputNumbersValue(input.value).length === 1) {
      input.value = '';
      return null;
    }
    if (handleBackspaceAtStart(input, event) || handleBackspaceInParentheses(input, event) || handleBackspaceAtSpecialPositions(input, event)) {
      return null;
    }
  }
  return input;
};
const handlePhonePaste = event => {
  const pasted = event.clipboardData ?? window.clipboardData;
  const input = event.target;
  const inputNumbersValue = getInputNumbersValue(input.value);
  input.value = '';
  if (pasted) {
    const pastedText = pasted.getData('Text');
    if (PATTERN.test(pastedText)) {
      input.value = inputNumbersValue;
    }
  }
};
function InputPhone(props) {
  const $ = _c(16);
  const {
    field,
    testid,
    onFocus
  } = props;
  const t0 = props.page === "visual" ? props.inputClassName : style.inputPhone;
  const t1 = props.placeholder;
  const t2 = Boolean(props.errors);
  let t3;
  if ($[0] !== field || $[1] !== onFocus || $[2] !== props.placeholder || $[3] !== t0 || $[4] !== t2 || $[5] !== testid) {
    t3 = <input {...field} data-testid={testid} type="tel" autoComplete="tel" className={t0} maxLength={18} placeholder={t1} onFocus={onFocus} onInput={_temp} onKeyDown={_temp2} onPaste={_temp3} data-has-error={t2} id="inputId" />;
    $[0] = field;
    $[1] = onFocus;
    $[2] = props.placeholder;
    $[3] = t0;
    $[4] = t2;
    $[5] = testid;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = props.page === "visual" ? props.labelClassName : style.inputLabel;
  const t5 = props.label || "\u0422\u0435\u043B\u0435\u0444\u043E\u043D";
  let t6;
  if ($[7] !== t4 || $[8] !== t5) {
    t6 = <label htmlFor="inputId" className={t4}>{t5}</label>;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const t7 = props.errors && props.errorLabel;
  let t8;
  if ($[10] !== t7) {
    t8 = <div className={style.inputError}>{t7}</div>;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t3 || $[13] !== t6 || $[14] !== t8) {
    t9 = <>{t3}{t6}{t8}</>;
    $[12] = t3;
    $[13] = t6;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  return t9;
}
function _temp3(e_1) {
  return handlePhonePaste(e_1);
}
function _temp2(e_0) {
  return handlePhoneKeyDown(e_0);
}
function _temp(e) {
  return handlePhoneInput(e);
}
export default InputPhone;